import { useEffect, useState } from 'react';
import { loadTenantThemeSettings, applyTenantTheme, getTenantLogo, getTenantFavicon } from '@/utils/tenantThemeLoader';
import { TenantThemeSettings } from '@/utils/tenantThemeLoader';

export const useTenantTheme = () => {
  const [settings, setSettings] = useState<TenantThemeSettings | null>(null);
  const [logo, setLogo] = useState<string | null>(null);
  const [favicon, setFavicon] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const loadTheme = async () => {
      try {
        setIsLoading(true);
        
        // Load theme settings
        const themeSettings = await loadTenantThemeSettings();
        setSettings(themeSettings);
        
        // Apply theme to the page
        applyTenantTheme(themeSettings);
        
        // Load logo and favicon separately for easy access
        const logoUrl = await getTenantLogo();
        const faviconUrl = await getTenantFavicon();
        
        setLogo(logoUrl);
        setFavicon(faviconUrl);
      } catch (error) {
        console.error('Error loading tenant theme:', error);
        // Apply default theme on error
        applyTenantTheme(null);
      } finally {
        setIsLoading(false);
      }
    };

    loadTheme();
  }, []);

  return {
    settings,
    logo,
    favicon,
    isLoading,
  };
}; 